import { render } from "./GenerateApiKeyPair.vue?vue&type=template&id=3279f7e0&scoped=true"
import script from "./GenerateApiKeyPair.vue?vue&type=script&lang=js"
export * from "./GenerateApiKeyPair.vue?vue&type=script&lang=js"

import "./GenerateApiKeyPair.vue?vue&type=style&index=0&id=3279f7e0&scoped=true&lang=less"

import exportComponent from "/mnt/build/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3279f7e0"]])

export default __exports__